import { Dialog, DialogContent, DialogTitle, DialogProps } from '@mui/material';
import { Breakpoint } from '@mui/material'; // TODO: Import from ui kit
import { ReactNode } from 'react';
import { CloseButton } from './CloseButton';

const BaseDialog = (props: {
  open: boolean;
  title: ReactNode;
  onClose?: () => void;
  children?: ReactNode;
  className?: string;
  maxWidth?: Breakpoint;
  id?: string;
  onClick?: DialogProps['onClick'];
}) => {
  const { open, onClose, className, maxWidth, id } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDialogContent-root': { padding: 2 },
        '& a': {
          textDecoration: 'none',
          color: 'var(--nd-blue-dark)',
        },
      }}
      fullWidth
      maxWidth={maxWidth ?? 'sm'}
      className={className}
      id={id}
      onClick={props.onClick}
    >
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>
        {props.title}
        <CloseButton onClick={onClose} />
      </DialogTitle>
      <DialogContent dividers>{props.children}</DialogContent>
    </Dialog>
  );
};

export default BaseDialog;
